import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/gloable.css';
import request from "@/util/request";
import store from "@/store";
import htmlToExcel from "@/util/htmlToExcel";
import htmlToPdf from "@/util/htmlToPdf";

Vue.config.productionTip = false
Vue.use(ElementUI, {size: "mini"});
Vue.use(ElementUI);
ElementUI.Dialog.props.closeOnClickModal.default = false
Vue.prototype.request = request;
Vue.prototype.htmlToExcel = htmlToExcel;

// Vue.prototype.uploadCertFile = "http://localhost:8082/common/upload/finance/certFile/";// 上传图片的路径
// Vue.prototype.uploadOtherFile = "http://localhost:8082/common/upload/finance/otherFile/";// 上传图片的路径
// Vue.prototype.uploadRemitFile = "http://localhost:8082/common/upload/finance/remitFile/";// 上传图片的路径
// Vue.prototype.uploadEmpIdCardImgUrl = "http://localhost:8082/common/upload/emp/idCard";// 上传图片的路径
// Vue.prototype.uploadEmpContractImgUrl = "http://localhost:8082/common/upload/emp/contract";// 上传图片的路径
// Vue.prototype.uploadContractImgUrl = "http://localhost:8082/common/upload/contract/";// 上传图片的路径
// Vue.prototype.uploadDiscountImgUrl = "http://localhost:8082/common/upload/discount/";// 上传图片的路径
// Vue.prototype.uploadLeaveImgUrl = "http://localhost:8082/common/upload/leave/";// 上传图片的路径
// Vue.prototype.uploadOvertimeImgUrl = "http://localhost:8082/common/upload/overtime/";// 上传图片的路径
// Vue.prototype.exportUserUrl = "http://localhost:8082/user/export/";// 导出用户的路径
// Vue.prototype.exportGoodsUrl = "http://localhost:8082/approvalGoodsInfo/export/";// 导出申购单的路径
// Vue.prototype.exportGoodsExcelUrl = "http://localhost:8082/approvalGoodsInfo/exportExcel";// 导出申购单汇总的路径
// Vue.prototype.exportFinanceUrl = "http://localhost:8082/approvalFinanceInfo/export/";// 导出报销单的路径
// Vue.prototype.exportFinanceExcelUrl = "http://localhost:8082/approvalFinanceInfo/exportExcel";// 导出报销单汇总的路径
// Vue.prototype.exportDiscountUrl = "http://localhost:8082/approvalDiscountInfo/export/";// 导出费用打折的路径
// Vue.prototype.exportContractUrl = "http://localhost:8082/approvalContractInfo/export/";// 导出合同审批的路径
// Vue.prototype.exportLeaveUrl = "http://localhost:8082/approvalLeaveInfo/export/";// 导出请假申请的路径
// Vue.prototype.exportOvertimeUrl = "http://localhost:8082/approvalOvertimeInfo/export/";// 导出加班申请的路径
// Vue.prototype.exportReceiptUrl = "http://localhost:8082/receipt/export/";// 导出收据pdf的路径
// Vue.prototype.exportReceiptExcelUrl = "http://localhost:8082/receipt/exportExcel";// 导出收据汇总的路径
// Vue.prototype.exportMaintenanceUrl = "http://localhost:8082/engineeringMaintenance/export/";// 导出维修单pdf的路径
// Vue.prototype.exportMaintenanceExcelUrl = "http://localhost:8082/engineeringMaintenance/exportExcel";// 导出维修单汇总的路径
// Vue.prototype.exportTradeExcelUrl = "http://localhost:8082/trade/exportExcel";// 导出收支
// Vue.prototype.statTradeExcelUrl = "http://localhost:8082/trade/statExcel";// 统计收支

Vue.prototype.uploadCertFile = "https://taolemon.com/propMan/common/upload/finance/certFile/";// 上传图片的路径
Vue.prototype.uploadOtherFile = "https://taolemon.com/propMan/common/upload/finance/otherFile/";// 上传图片的路径
Vue.prototype.uploadRemitFile = "https://taolemon.com/propMan/common/upload/finance/remitFile/";// 上传图片的路径
Vue.prototype.uploadEmpIdCardImgUrl = "https://taolemon.com/propMan/common/upload/emp/idCard";// 上传图片的路径
Vue.prototype.uploadEmpContractImgUrl = "https://taolemon.com/propMan/common/upload/emp/contract";// 上传图片的路径
Vue.prototype.uploadContractImgUrl = "https://taolemon.com/propMan/common/upload/contract/";// 上传图片的路径
Vue.prototype.uploadDiscountImgUrl = "https://taolemon.com/propMan/common/upload/discount/";// 上传图片的路径
Vue.prototype.uploadLeaveImgUrl = "https://taolemon.com/propMan/common/upload/leave/";// 上传图片的路径
Vue.prototype.uploadOvertimeImgUrl = "https://taolemon.com/propMan/common/upload/overtime/";// 上传图片的路径
Vue.prototype.exportUserUrl = "https://taolemon.com/propMan/user/export/";// 导出用户的路径
Vue.prototype.exportGoodsUrl = "https://taolemon.com/propMan/approvalGoodsInfo/export/";// 导出申购单的路径
Vue.prototype.exportGoodsExcelUrl = "https://taolemon.com/propMan/approvalGoodsInfo/exportExcel";// 导出申购单汇总的路径
Vue.prototype.exportFinanceUrl = "https://taolemon.com/propMan/approvalFinanceInfo/export/";
Vue.prototype.exportFinanceExcelUrl = "https://taolemon.com/propMan/approvalFinanceInfo/exportExcel";
Vue.prototype.exportDiscountUrl = "https://taolemon.com/propMan/approvalDiscountInfo/export/";// 导出费用打折的路径
Vue.prototype.exportContractUrl = "https://taolemon.com/propMan/approvalContractInfo/export/";// 导出合同审批的路径
Vue.prototype.exportLeaveUrl = "https://taolemon.com/propMan/approvalLeaveInfo/export/";// 导出请假申请的路径
Vue.prototype.exportOvertimeUrl = "https://taolemon.com/propMan/approvalOvertimeInfo/export/";// 导出加班申请的路径
Vue.prototype.exportReceiptUrl = "https://taolemon.com/propMan/receipt/export/";// 导出收据pdf的路径
Vue.prototype.exportReceiptExcelUrl = "https://taolemon.com/propMan/receipt/exportExcel";// 导出收据汇总的路径
Vue.prototype.exportMaintenanceUrl = "https://taolemon.com/propMan/engineeringMaintenance/export/";// 导出维修单pdf的路径
Vue.prototype.exportMaintenanceExcelUrl = "https://taolemon.com/propMan/engineeringMaintenance/exportExcel";// 导出维修单汇总的路径
Vue.prototype.exportTradeExcelUrl = "https://taolemon.com/propMan/trade/exportExcel";// 导出收支
Vue.prototype.statTradeExcelUrl = "https://taolemon.com/propMan/trade/statExcel";// 统计收支

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
